// Library Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import authAxios from '@/redux/http';
import endPoints from '@/redux/constant';

// Create a thunk for chargebeePayments
export const chargebeePaymentsThunk = createAsyncThunk(
  "payment/chargebeePayments",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(endPoints.chargebeePayments, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Create a thunk for getTaxAmountQuaderno
export const getTaxAmountThunk = createAsyncThunk(
  "payment/getTaxAmount",
  async ({ country, state, zipCode, amount }, { rejectWithValue }) => {
    try {
      // Construct the full URL with parameters
      const url = `${endPoints.getQuadernoTaxAmount}${country}&state=${state}&zip=${zipCode}&amount=${amount}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Create a thunk for getUpdatePaymentMethodUrl
export const getUpdatePaymentMethodUrlThunk = createAsyncThunk(
  "payment/getUpdatePaymentMethodUrl",
  async ({ userId, redirectUrl }, { rejectWithValue }) => {
    try {
      const response = await authAxios.post(
        `${endPoints.updatePaymentMethodType}?userId=${userId}&redirectUrl=${encodeURIComponent(redirectUrl)}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Create a thunk for getCustomerPaymentMethod
export const getCustomerPaymentMethodThunk = createAsyncThunk(
  "payment/getCustomerPaymentMethod",
  async ({ userId }, { rejectWithValue }) => {
    try {
      const response = await authAxios.get(
        `${endPoints.getCustomerPaymentMethod}?UserId=${userId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.response?.data);
    }
  }
);

// Create a slice for payment
const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    loading: false,
    error: null,
    taxAmount: 0,
    paymentMethod: null,
    paymentMethodLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTaxAmountThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTaxAmountThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.taxAmount = action.payload.result || 0;
      })
      .addCase(getTaxAmountThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(chargebeePaymentsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(chargebeePaymentsThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(chargebeePaymentsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getCustomerPaymentMethodThunk.pending, (state) => {
        state.paymentMethodLoading = true;
      })
      .addCase(getCustomerPaymentMethodThunk.fulfilled, (state, action) => {
        state.paymentMethodLoading = false;
        state.paymentMethod = action.payload?.result || null;
      })
      .addCase(getCustomerPaymentMethodThunk.rejected, (state) => {
        state.paymentMethodLoading = false;
        state.paymentMethod = null;
      });
  },
});

export default paymentSlice.reducer;
